import React, { useEffect, useState } from "react";
// Custom Component
import WeddingDate from "../../components/wedding-date/WeddingDate";
import Countdown from "../../components/countdown/Countdown";
import LoadingModal from "../../components/loading/LoadingModal";
// Assets
import doubleHappiness from "../../assets/image/xixi_2.svg";
import Venue from "../../components/venue/Venue";
// Style
import styles from "./landing.module.css";
import RSVP from "../../components/rsvp/RSVP";
import PolaroidCarousel from "../../components/polaroid-image/PolaroidCarousel";
import { useLanguage } from "../../utils/language";
import LanguageSwitchButton from "./LanguageSwitchButton";
import { getWeddingDate } from "../../utils/firebase/remote-config/remote-config-utils";

function Landing(props) {
  const { isLandingLoading } = props;
  const { getTranslation } = useLanguage();
  const [weddingDate, setWeddingDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setWeddingDate(new Date(getWeddingDate()));
    setIsLoading(false);
  }, []);

  if (isLandingLoading) {
    return <LoadingModal isLoading={true} />;
  }

  return (
    <section className={styles.background}>
      <LanguageSwitchButton />
      <img src={doubleHappiness} alt="" className={styles.headerImage} />
      <div className={styles.landingTitleContainer}>
        <h2
          dangerouslySetInnerHTML={{ __html: getTranslation("landing_title") }}
          className={styles.landingTitle}
        />
      </div>
      <div className={styles.nameContainer}>
        <p className={styles.nameText}>Simon Lim</p>
        <p className={styles.nameTextAmp}>&amp;</p>
        <p className={styles.nameText}>Esther Koh</p>
      </div>
      <WeddingDate />
      <Venue />
      <PolaroidCarousel />
      <Countdown targetDate={weddingDate} />
      <RSVP />
      <LoadingModal isLoading={isLoading} />
    </section>
  );
}

export default Landing;
